<template>
  <div
    v-on:click="$emit('click')"
    class="cell"
    :class="{ disabled: gameOver === true }"
  >
    <span
      v-if="value !== ''"
      :class="{ red: value === 'x', green: value === 'o' }"
      >{{ value }}</span
    >
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    gameOver: Boolean
  }
};
</script>
<style scoped>
.cell {
  width: 110px;
  height: 110px;
  border: 2px solid grey;
  background: lightgrey;
  font-size: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.red {
  color: rgb(249, 116, 34);
}
.green {
  color: rgb(190, 217, 72);
}
.red,
.green {
  position: relative;
  top: -6px;
  font-weight: bold;
  font-size: 80px;
}
.disabled {
  pointer-events: none;
}
</style>
